
import { updateAnalyticsState } from '@/analytics-loader'
import Storage from '@/storage'

/**
 * @type {object}
 */
const CookieConsentManager = {
    /**
     * Returns true if the user has specified their cookie preferences, otherwise false.
     *
     * @returns {Promise<boolean>}
     */
    async hasSetConsentAsync() {
        const consent = await this.getConsentDataAsync()

        return consent.setByUser
    },

    /**
     * Returns the cookie consent data stored.
     *
     * @returns {Promise<CookieConsent>}
     */
    async getConsentDataAsync() {
        return await Storage.consent.getAsync()
    },

    /**
     * Consent to the specified cookie consent settings.
     * @param {CookieConsent} consent
     * @returns {Promise}
     */
    async setConsentDataAsync(consent) {
        updateAnalyticsState(consent.analytics)

        await Storage.consent.setAsync(consent)
    },
}

export default CookieConsentManager
